import React from "react";
import {
  Avatar,
  Button,
  Flex,
  Icon,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  Button as AntdButton,
  Col,
  DatePicker,
  Divider,
  Input,
  message,
  Modal,
  Popconfirm,
  Row,
  Select,
  Spin,
} from "antd";
import { Alert } from "components/Alert/Alert";
import { Controller } from "Controller/Controller";
import { Rules } from "errorHandling/Rules";
import { useEffect, useMemo, useState } from "react";
import { FaPlus } from "react-icons/fa";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

const CreateBusinessMember = (props) => {
  // windows width
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);

  useEffect(() => {
    checkAccount();

    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { columnsData, tableData } = {};
  const columns = useMemo(() => columnsData, [columnsData]);
  const [loadingCreate, setLoadingCreate] = useState(false);

  const data = useMemo(() => tableData, [tableData]);
  const iconColor = useColorModeValue("brand.500", "white");
  const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");

  const bgHover = useColorModeValue(
    { bg: "secondaryGray.400" },
    { bg: "whiteAlpha.50" }
  );
  const bgFocus = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.100" }
  );

  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = useColorModeValue("secondaryGray.600", "white");

  const [basicEditValues, setBasicEditValues] = useState({
    first_name: "",
    last_name: "",
    address: "",
    city: "",
    state: "",
    email: "",
    phone: "",
    zip_code: "",
    country: "ca",
    dateOfBirth: null,
    id: -1,
  });
  const [visibleCreateMemberModal, setVisibleCreateMemberModal] =
    useState(false);
  const [newMember, setNewMember] = useState({
    business_name: "",
    address: "",
    city: "",
    state: "",
    email: "",
    phone: "",
    contact_person: {
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
    },
  });
  const [permission, setPermission] = useState("loading");
  const [fieldErrors, setFieldErrors] = useState({
    business_name: "",
    address: "",
    city: "",
    state: "",
    email: "",
    phone: "",
  });
  // functions

  const checkAccount = async () => {
    const response = await Controller.checkConnectedAccount();
    if (!response.detail) {
      setPermission(false);
    } else if (!response.detail.is_verified) {
      setPermission(false);
    } else {
      setPermission(false);
    }
  };

  const handleChangeEdit = (e) => {
    const { name, value } = e.target;
    setBasicEditValues({
      ...basicEditValues,
      [name]: value,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Handle nested fields (contact_person.*)
    if (name.includes(".")) {
      const [parent, child] = name.split(".");
      setNewMember((prev) => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value,
        },
      }));
    } else {
      // Handle top-level fields
      setNewMember((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleCreateMember = async () => {
    setLoadingCreate(true);
    // Clear previous errors
    setFieldErrors({
      business_name: "",
      address: "",
      city: "",
      state: "",
      email: "",
      phone: "",
    });

    if (newMember.phone && newMember.phone.length != 10) {
      const errors = {
        phone: "Enter 10 char!",
      };

      setFieldErrors(errors);
    } else {
      var payload = {
        business_name: newMember.business_name,
        address: newMember.address,
        city: newMember.city,
        state: newMember.state,
        email: newMember.email,
        phone: newMember.phone,
        zip_code: newMember.zip_code,
        office: localStorage.getItem("selectedOffice"),
        notify_member: false,
        is_enrollment: true,
        contact_person: {
          first_name: newMember.contact_person.first_name,
          last_name: newMember.contact_person.last_name,
          email: newMember.contact_person.email,
          phone: newMember.contact_person.phone,
        },
      };
      console.log(newMember);
      try {
        const response = await Controller.createNewMemberBusiness(payload);
        if (response.status < 250) {
          Alert.openNotification(
            response.message ? response.message : "Successful",
            "success"
          );
          //props.getMemberData();
          props.handleCreateBusinessMember(response.json.id);
          setVisibleCreateMemberModal(false);
          setNewMember({
            first_name: "",
            last_name: "",
            address: "",
            city: "",
            state: "",
            email: "",
            phone: "",
            zip_code: "",
            country: "ca",
            dateOfBirth: null,
            contact_person: {
              first_name: "",
              last_name: "",
              phone: "",
              email: "",
            },
          });
        } else {
          const errors = {};
          if (response.json) {
            Object.keys(response.json).forEach((key) => {
              if (key in fieldErrors) {
                errors[key] = response.json[key][0]; // Take the first error message
              }
            });
          }

          setFieldErrors(errors);

          Alert.openNotification(
            response.json.detail
              ? response.json.detail[0]
              : response.json.first_name
              ? response.json.first_name[0]
              : response.json.last_name
              ? response.json.last_name[0]
              : response.json.address
              ? response.json.address[0]
              : response.json.city
              ? response.json.city[0]
              : response.json.state
              ? response.json.state[0]
              : response.json.email
              ? response.json.email[0]
              : response.json.phone
              ? response.json.phone[0]
              : response.json.zip_code
              ? response.json.zip_code[0]
              : response.json.country
              ? response.json.country[0]
              : response.json.dateOfBirth
              ? response.json.dateOfBirth[0]
              : response.json.postalCode
              ? response.json.postalCode[0]
              : response.json.address1
              ? response.json.address1[0]
              : response.json.fullname
              ? response.json.fullname[0]
              : "Error",

            "error"
          );
        }
      } catch (error) {
        console.log(error);
      }
    }

    setLoadingCreate(false);
  };

  const handleOpenDatePicker = (e) => {
    setOpenDatePicker(e);
  };

  const handleCloseAddMember = () => {
    setNewMember({
      first_name: "",
      last_name: "",
      address: "",
      city: "",
      state: "",
      email: "",
      phone: "",
      zip_code: "",
      country: "ca",
      dateOfBirth: null,
    });
    setVisibleCreateMemberModal(false);
  };

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleCreateMember();
        }}
      >
        {/* Business Information Section */}
        <div className="custom-divider">
          <span style={{ fontSize: "16px", color: "rgba(0,0,0,0.68)" }}>
            Business Information
          </span>
          <div className="line"></div>
        </div>

        <Row type="flex" justify="space-between" gutter={[25]}>
          <Col span={24}>
            <label className="formLabel">
              <span style={{ color: "red", marginRight: "4px" }}>*</span>{" "}
              Business Name
            </label>
            <Input
              className="inputs"
              onChange={handleChange}
              type="text"
              name="business_name"
              placeholder="Example Business"
              value={newMember.business_name}
              // required
            />
          </Col>
        </Row>

        <Row type="flex" justify="space-between" gutter={[25]}>
          <Col span={windowDimensions.width < 450 ? 24 : 12}>
            <label className="formLabel"><span style={{ color: 'red', marginRight: '4px' }}>*</span> Email</label>
            <Input
              className="inputs"
              onChange={handleChange}
              type="email"
              name="email"
              placeholder="example@email.com"
              value={newMember.email}
              status={fieldErrors.email ? "error" : ""}
              // required
            />
            {fieldErrors.email && (
              <div style={{ color: "red", marginTop: "5px" }}>
                {fieldErrors.email}
              </div>
            )}
          </Col>
          <Col span={windowDimensions.width < 450 ? 24 : 12}>
            <label className="formLabel"><span style={{ color: 'red', marginRight: '4px' }}>*</span> Phone</label>
            <Input
              className="inputs"
              onChange={handleChange}
              type="text"
              name="phone"
              placeholder="1234567890"
              value={newMember.phone}
              status={fieldErrors.phone ? "error" : ""}
              //required
            />
            {fieldErrors.phone && (
              <div style={{ color: "red", marginTop: "5px" }}>
                {fieldErrors.phone}
              </div>
            )}
          </Col>
        </Row>

        <Row type="flex" justify="space-between" gutter={[25]}>
          <Col span={windowDimensions.width < 450 ? 24 : 12}>
            <label className="formLabel">Address</label>
            <Input
              className="inputs"
              onChange={handleChange}
              type="text"
              name="address"
              placeholder="123 Example Street"
              value={newMember.address}
              status={fieldErrors.address ? "error" : ""}
              // required
            />
            {fieldErrors.address && (
              <div style={{ color: "red", marginTop: "5px" }}>
                {fieldErrors.address}
              </div>
            )}
          </Col>
          <Col span={windowDimensions.width < 450 ? 24 : 12}>
            <label className="formLabel">City</label>
            <Input
              className="inputs"
              onChange={handleChange}
              type="text"
              name="city"
              placeholder="Example City"
              value={newMember.city}
              status={fieldErrors.city ? "error" : ""}
              //required
            />
            {fieldErrors.city && (
              <div style={{ color: "red", marginTop: "5px" }}>
                {fieldErrors.city}
              </div>
            )}
          </Col>
        </Row>

        <Row type="flex" justify="space-between" gutter={[25]}>
          <Col span={windowDimensions.width < 450 ? 24 : 12}>
            <label className="formLabel">State</label>
            <Input
              className="inputs"
              onChange={handleChange}
              type="text"
              name="state"
              placeholder="Example State"
              status={fieldErrors.state ? "error" : ""}
              value={newMember.state}
              // required
            />
            {fieldErrors.state && (
              <div style={{ color: "red", marginTop: "5px" }}>
                {fieldErrors.state}
              </div>
            )}
          </Col>
          <Col span={windowDimensions.width < 450 ? 24 : 12}>
            <label className="formLabel">Zip Code</label>
            <Input
              className="inputs"
              onChange={handleChange}
              type="text"
              name="zip_code"
              placeholder="A1A1A1"
              value={newMember.zip_code}
              status={fieldErrors.zip_code ? "error" : ""}
            />
            {fieldErrors.zip_code && (
              <div style={{ color: "red", marginTop: "5px" }}>
                {fieldErrors.zip_code}
              </div>
            )}
          </Col>
        </Row>

        {/* Contact Person Section */}
        <div className="custom-divider">
          <span style={{ fontSize: "16px", color: "rgba(0,0,0,0.68)" }}>
            Contact Person
          </span>
          <div className="line"></div>
        </div>
        <Row gutter={[25]}>
          <Col span={windowDimensions.width < 450 ? 24 : 12}>
            <label className="formLabel"><span style={{ color: 'red', marginRight: '4px' }}>*</span> First Name</label>
            <Input
              className="inputs"
              onChange={(e) =>
                handleChange({
                  target: {
                    name: "contact_person.first_name",
                    value: e.target.value,
                  },
                })
              }
              type="text"
              placeholder="John"
              value={newMember.contact_person?.first_name || ""}
              status={fieldErrors.contact_person?.first_name ? "error" : ""}
            />
            {fieldErrors.contact_person?.first_name && (
              <div style={{ color: "red", marginTop: "5px" }}>
                {fieldErrors.contact_person.first_name}
              </div>
            )}
          </Col>
          <Col span={windowDimensions.width < 450 ? 24 : 12}>
            <label className="formLabel"><span style={{ color: 'red', marginRight: '4px' }}>*</span> Last Name</label>
            <Input
              className="inputs"
              onChange={(e) =>
                handleChange({
                  target: {
                    name: "contact_person.last_name",
                    value: e.target.value,
                  },
                })
              }
              type="text"
              placeholder="Doe"
              value={newMember.contact_person?.last_name || ""}
              status={fieldErrors.contact_person?.last_name ? "error" : ""}
            />
            {fieldErrors.contact_person?.last_name && (
              <div style={{ color: "red", marginTop: "5px" }}>
                {fieldErrors.contact_person.last_name}
              </div>
            )}
          </Col>
        </Row>

        <Row gutter={[25]}>
          <Col span={windowDimensions.width < 450 ? 24 : 12}>
            <label className="formLabel"><span style={{ color: 'red', marginRight: '4px' }}>*</span> Contact Phone</label>
            <Input
              className="inputs"
              onChange={(e) =>
                handleChange({
                  target: {
                    name: "contact_person.phone",
                    value: e.target.value,
                  },
                })
              }
              type="text"
              placeholder="0987654321"
              value={newMember.contact_person?.phone || ""}
              status={fieldErrors.contact_person?.phone ? "error" : ""}
            />
            {fieldErrors.contact_person?.phone && (
              <div style={{ color: "red", marginTop: "5px" }}>
                {fieldErrors.contact_person.phone}
              </div>
            )}
          </Col>
          <Col span={windowDimensions.width < 450 ? 24 : 12}>
            <label className="formLabel"><span style={{ color: 'red', marginRight: '4px' }}>*</span> Contact Email</label>
            <Input
              className="inputs"
              onChange={(e) =>
                handleChange({
                  target: {
                    name: "contact_person.email",
                    value: e.target.value,
                  },
                })
              }
              type="email"
              placeholder="person@example.com"
              value={newMember.contact_person?.email || ""}
              status={fieldErrors.contact_person?.email ? "error" : ""}
            />
            {fieldErrors.contact_person?.email && (
              <div style={{ color: "red", marginTop: "5px" }}>
                {fieldErrors.contact_person.email}
              </div>
            )}
          </Col>
        </Row>

        <div
          className="btnBox"
          style={{ display: "flex", justifyContent: "end", marginTop: "15px" }}
        >
          <AntdButton
            onClick={handleCloseAddMember}
            className="white-btn create-payment-request-btn"
          >
            Close
          </AntdButton>
          <AntdButton
            htmlType="submit"
            type="primary"
            loading={loadingCreate}
            className="login-btn create-payment-request-btn"
            style={{ marginLeft: "5px", minWidth: "120px" }}
          >
            {loadingCreate ? "Creating..." : "Create"}
          </AntdButton>
        </div>
      </form>
    </>
  );
};

export default CreateBusinessMember;
